<template>
  <div class="plus-components">
    <div
      v-show="cms && cms.length"
      v-for="(e, i) in cms"
      :key="'cms-' + (i + 1) + parseInt(Math.random() * 1000, 10)"
      class="cms-module"
    >
      <CmsComponents
        :componentsName="e.cardModelLabel"
        :item="e"
        :itemIndex="i"
        :isAnimation="isAnimation"
        :cmsData="$root.user.dataSourceCms.data"
        @init-load="cardLoading"
      />
    </div>
    <slot v-if="!(cms && cms.length) && loading" />
  </div>
</template>

<script>
import CmsComponents from '$common/components/cms-components';
import { appConfigCmstopicGetTopicPage, queryCityByGeo } from '$common/api/app-config';

export default {
  props: {
    pageLable: {
      type: String,
      default: () => ''
    },
    isOpenError: {
      type: Boolean,
      default: () => false
    },
    beforeInterceptors: {
      type: Function
    }
  },
  components: { CmsComponents },
  watch: {
    pageLable(val) {
      this.getCms();
    }
  },
  mounted() {
    if (this.pageLable) {
      this.getCms();
    }
    if (process.env.NODE_ENV === 'development') {
      //  广州环境
      this.defaultRet = { latitude: '23.122538', longitude: '113.395651' }
    }
  },
  data() {
    return {
      isAnimation: true,
      loading: false,
      resetCount: 0,
      //  310
      defaultRet: { latitude: '11.5519716', longitude: '104.9262234' }
    };
  },
  computed: {
    cms() {
      if (this.beforeInterceptors) {
        return this.beforeInterceptors(this.$root.user.dataSourceCms?.data?.cards ?? [])
      }
      return this.$root.user.dataSourceCms?.data?.cards ?? []
    }
  },
  methods: {
    cardLoading(item) {
      this.$root.timeout(() => this.$set(this.$root.user.dataSourceCms.data.cards[item.cardItemIndex], 'isLoading', true), 10);
    },
    loadCms() {
      this.loading = true;
      if (!(this.$root.user.dataSourceCms?.data)) {
        return;
      }
      this.$emit('load', this.$root.user.dataSourceCms.data);
    },
    getPosition(count = 0) {
      const self = this;
      return new Promise(resolve => {
        if (window?.WOWNOW?.getLocation) {
          let isSuccess = false;
          return window?.WOWNOW?.getLocation({
              success: (location) => {
                isSuccess = true;
                console.log('从 app 获取到原生经纬度: ', location)
                resolve({ data: {
                  latitude: location?.latitude?.toString(),
                  longitude: location?.longitude?.toString(),
                  getLocationSuccess: !!(location?.latitude && location?.longitude)
                } })
              },
              complete: () => {
                this.$root.timeout(() => {
                  if (!isSuccess) {
                    resolve({ error: arguments });
                  }
                }, 500);
              }
            })
        }
        if (navigator.geolocation) {
          return navigator.geolocation.getCurrentPosition(function (position) {
            console.log('从浏览器获取到经纬度: ', position)
            resolve({ data: {
              latitude: position?.coords?.latitude?.toString(),
              longitude: position?.coords?.longitude?.toString(),
              getLocationSuccess: !!(position?.coords?.latitude && position?.coords?.longitude)
            } })
          }, function () {
            if (count < 3) {
              return self.$root.timeout(() => resolve(self.getPosition(count + 1)), 500);
            }
            resolve({ error: arguments })
          })
        } else {
          if (count < 3) {
            return self.$root.timeout(() => {
              resolve(self.getPosition(count + 1))
            }, 500);
          }
          console.log('sdk 未加载完 默认金边经纬度!')
          resolve({ error: new Error('你的浏览器不支持当前地理位置信息获取') });
        }
      })
    },
    queryCityByGeo() {
      return new Promise(resolve => {
        queryCityByGeo({
          lat: this.$root.user.position.latitude,
          lon: this.$root.user.position.longitude,
        }, {
          isOpenError: this.isOpenError,
          success: res => {
            resolve(res.cityCode || 'PNH')
          },
          fail: error => {
            resolve('PNH')
          },
          isBlockException: true
        });
      })
    },
    getCms() {
      if (this.pageLable && !(this.$root?.user?.appConfigCmstopicGetTopicPage)) {
        console.log('this.$root.user: ', this.$root.user)
        this.$root.user.appConfigCmstopicGetTopicPage = true;
        return this.getPosition().then(async ({ data: position }) => {
          if (!!(position?.getLocationSuccess)) {
            this.$root.user.position = position;
          } else {
            console.log('获取默认金边坐标')
            this.$root.user.position = {
              latitude: this.defaultRet.latitude,
              longitude: this.defaultRet.longitude,
              getLocationSuccess: true
            };
          }
          let cityCode = await this.queryCityByGeo()
          this.$root.user.position.cityCode = cityCode
          appConfigCmstopicGetTopicPage({
            pageNo: this.pageLable,
            cityCode
          }, { isOpenError: this.isOpenError, success: res => {
            if (res?.resultCode === null) {
              if (this.resetCount < 3) {
                ++this.resetCount;
                return this.getCms()
              }
            }
            Object.keys(res).forEach(field => {
              try {
                try {
                  res[field] = JSON.parse(decodeURIComponent(res[field]))
                } catch(er) {
                  res[field] = JSON.parse(res[field])
                }
              } catch(error) {}
            })
            console.log('appConfigCmstopicGetTopicPage res: ', res)
            const ret = {
              cards: (res?.modelListInfo ?? []).map((e, i) => {
                const __data = { ...e, cardModelLabel: e.modelName, cardItemIndex: i, isLoading: false };
                Object.keys(__data).forEach(q => {
                  try {
                    __data[q] = JSON.parse(decodeURIComponent(__data[q]))
                  } catch(error) {}
                });
                return __data;
              }),
              pageShareInfo: res?.pageShareInfo ?? {}
            }

            try {
              const { pageStyle, pageExpand } = res;
              if (pageExpand) {
                switch(this.$i18n.locale) {
                  case 'zh':
                    ret.documentTitle = pageExpand?.pageCnName ?? '';
                    ret.pageDescription = pageExpand?.pageCnDescription ?? '';
                    break;
                  case 'km':
                    ret.documentTitle = pageExpand?.pageKhName ?? '';
                    ret.pageDescription = pageExpand?.pageKhDescription ?? '';
                    break;
                  default:
                    ret.documentTitle = pageExpand?.pageEnName ?? '';
                    ret.pageDescription = pageExpand?.pageEnDescription ?? '';
                    break;
                };
                this.$root.updateDocumentTitle(ret.documentTitle);
                ret.pageDescriptionBgColor = pageExpand?.pageDescriptionBgColor ?? '';
                ret.pageDescriptionColor = pageExpand?.pageDescriptionColor ?? '';
                ret.pageDescriptionStyle = pageExpand?.pageDescriptionStyle ?? '';

                if (pageExpand?.pageAddress?.lat && pageExpand?.pageAddress?.lng) {
                  ret.pageAddress = {
                    latitude: pageExpand.pageAddress.lat.toString(),
                    longitude: pageExpand.pageAddress.lng.toString(),
                    getLocationSuccess: true
                  }
                }
              }
              if (pageStyle) {
                const { pageColor, pageBackground } = pageStyle;

                // ret.pageBackground = 'https://img-uat.tinhnow.com/wownow/files/pro/app/MEF/BF/BD/758c25ef060f4c0b94998197f595ac9a.jpg'
                if (pageColor) {
                  ret.pageColor = pageColor;
                }
                if (pageBackground) {
                  ret.pageBackground = pageBackground;
                }
              }
            } catch(error) {
              console.log('error: ', error);
            }
            console.log('dataSourceCms: ', ret)
            this.$set(this.$root.user.dataSourceCms, 'data', ret)
            this.loadCms()
          },
          fail: error => {
            console.log('getCms error: ', error)
            this.$root.timeout(() => {
              if (this.resetCount < 3) {
                ++this.resetCount;
                this.getCms()
              } else {
                this.$emit('load', false);
              }
            }, 50);
          },
          isBlockException: true
          });
        });
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .plus-components {
    padding-bottom: 2px;
  }
</style>
